import React from "react"
import Slider from "react-slick"
import Img from "gatsby-image"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import "./section-nosotras-news.scss"

const SectionNosotrasNews = ({ contennInfo }) => {
  const listItems = contennInfo.map((info, index) => (
    <div key={index}>
      <a
        className={"f-carousel-Nnews-item f-carousel-Nnews-pos-" + index}
        href={info.url}
      >
        <Img
          className="f-carousel-Nnews-imagen"
          fluid={
            info.imagenNoticiaMobile
              ? [
                  info.imagenNoticiaMobile.fluid,
                  {
                    ...info.imagenNoticia?.fluid,
                    media: `(min-width: 761px)`,
                  },
                ]
              : info.imagenNoticia?.fluid
          }
          alt={info.imagenNoticia.description}
        />
        <div className="f-carousel-Nnews-description">
          <h3>{info.tituloNoticia}</h3>
          <span
            dangerouslySetInnerHTML={{
              __html: info.descripcionNoticia.childContentfulRichText.html,
            }}
          ></span>
        </div>
      </a>
    </div>
  ))
  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: null,
  }
  return (
    <div className="f-SectionNosotrasNews">
      <div className="f-SectionNosotrasNews-title">
        <h2>Nosotras News</h2>
      </div>
      <Slider {...settings} className="f-carousel-Nnews">
        {listItems}
      </Slider>
    </div>
  )
}

export default SectionNosotrasNews
